import $ from 'jQuery'
import uiHelper from '@/helper/ui.js'
import store from '@/store'
import i18n from '@/i18n'

/**
 * 数据相关助手
 */
var dataHelper = () => {
	// 数据提供服务地址
	var dps = require(process.env.NODE_ENV === 'development' ? '@/dev/var.js' : '@/var.js').dps

	var getUrl = url => {
		return dps.base + url + dps.ext
	} // getUrl end

	var ui = uiHelper.instance

	// 数据传输
	var trans = param => {
		ui.loading(true)
		$.ajax({
			url: getUrl(param.url),
			dataType: 'json',
			jsonp: 'callback',
			jsonpCallback: 'dwrap',
			data: (typeof param.data === 'undefined') ? {} : param.data,
			type: (typeof param.method === 'undefined') ? 'GET' : param.method.toUpperCase(),
			success: rs => {
				if (!param.keepLoading) {
					ui.loading(false)
				}
				if (typeof param.originData !== 'undefined' && param.originData) {
					param.success(rs)
				} else {
					if (typeof rs.user !== 'undefined') {
						store.commit('user', rs.user)
					}
					if (rs.code < 0) {
						ui.msgbox(
							i18n.t('_error.warning') + i18n.t('_error.' + rs.data),
							'warning',
							idx => { rs.code === -100 ? window.location.href = '/' : null }
						)
						return
					}
					param.success(rs.data)
				}
			},
			error: rs => {
				ui.loading(false)
				if (typeof param.error !== 'undefined') {
					param.error(rs)
				} else {
					ui.msgbox(i18n.t('_error.systemError'), 'danger')
				}
			},
			complete: () => {
				if (param.complete) {
					param.complete()
				}
			}
		})
	}  // trans end

	return {
		trans: trans,   // 后台数据交互
		getUrl: getUrl  // 获取链接地址
	}
}

export default {
	install: function (Vue) {
		if (dataHelper.installed) {
			return
		}
		dataHelper.installed = true
		Vue.prototype.dataHelper = dataHelper()
	},

	instance: dataHelper()
}



// WEBPACK FOOTER //
// ./src/helper/data.js